import { lookupLocaleKey } from '@plato/shared-util/locale';
import type { Locale } from 'date-fns';
import { de, enGB, enUS, fr, frCH } from 'date-fns/locale';
import { useMemo } from 'react';
import { getNavigatorLanguages } from './locale.ts';

const supportedDateFnsLocales = {
    de: de,
    en: enUS,
    'en-GB': enGB,
    fr: fr,
    'fr-CH': frCH,
};

export function useDateFnsLocale(locale: string | string[] = getNavigatorLanguages()): Locale {
    return useMemo(
        () => lookupLocaleKey(supportedDateFnsLocales, locale) ?? supportedDateFnsLocales.de,
        [locale],
    );
}
